import {ReactElement} from 'react';

import {EmpionButton} from '../EmpionButton/EmpionButton';

interface Props {
  children: ReactElement;
  onClick: () => void;
  buttonColor: string;
  activeColor: string;
}
export const CarouselButton = ({children, onClick, buttonColor, activeColor}: Props) => {
  return (
    <EmpionButton
      onClick={onClick}
      sx={{
        minWidth: 0,
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: buttonColor,
        '&:hover': {backgroundColor: activeColor},
      }}
    >
      {children}
    </EmpionButton>
  );
};
